import { TestReportSummarization } from "../../models/test-report-summarization";

export interface TestReportSummarizationState {
  testReport: TestReportSummarization[];
  metadata: any;
  loading: boolean;
  error: any;
}

export const initialState: TestReportSummarizationState = {
  testReport: [],
  metadata: {},
  loading: false,
  error: null,
};
